import React from 'react';

/**
 * SVG pattern definitions for accessibility.
 * These patterns supplement color so data series are distinguishable
 * without relying solely on color perception.
 */
export function ChartPatternDefs(): React.ReactElement {
  return (
    <defs>
      <pattern id="pattern-solid" width="10" height="10" patternUnits="userSpaceOnUse">
        <rect width="10" height="10" fill="currentColor" />
      </pattern>
      <pattern id="pattern-diagonal" width="10" height="10" patternUnits="userSpaceOnUse">
        <rect width="10" height="10" fill="currentColor" />
        <path d="M-1,1 l2,-2 M0,10 l10,-10 M9,11 l2,-2" stroke="white" strokeWidth="2" />
      </pattern>
      <pattern id="pattern-horizontal" width="10" height="10" patternUnits="userSpaceOnUse">
        <rect width="10" height="10" fill="currentColor" />
        <line x1="0" y1="5" x2="10" y2="5" stroke="white" strokeWidth="2" />
      </pattern>
      <pattern id="pattern-vertical" width="10" height="10" patternUnits="userSpaceOnUse">
        <rect width="10" height="10" fill="currentColor" />
        <line x1="5" y1="0" x2="5" y2="10" stroke="white" strokeWidth="2" />
      </pattern>
      <pattern id="pattern-dots" width="10" height="10" patternUnits="userSpaceOnUse">
        <rect width="10" height="10" fill="currentColor" />
        <circle cx="5" cy="5" r="2" fill="white" />
      </pattern>
      <pattern id="pattern-crosshatch" width="10" height="10" patternUnits="userSpaceOnUse">
        <rect width="10" height="10" fill="currentColor" />
        <path d="M0,0 l10,10 M10,0 l-10,10" stroke="white" strokeWidth="1.5" />
      </pattern>
      <pattern id="pattern-zigzag" width="10" height="10" patternUnits="userSpaceOnUse">
        <rect width="10" height="10" fill="currentColor" />
        <path d="M0,5 l5,-5 l5,5" stroke="white" strokeWidth="1.5" fill="none" />
      </pattern>
      <pattern id="pattern-diamond" width="10" height="10" patternUnits="userSpaceOnUse">
        <rect width="10" height="10" fill="currentColor" />
        <path d="M5,0 l5,5 l-5,5 l-5,-5 z" stroke="white" strokeWidth="1.5" fill="none" />
      </pattern>
      <pattern id="pattern-wave" width="10" height="10" patternUnits="userSpaceOnUse">
        <rect width="10" height="10" fill="currentColor" />
        <path d="M0,5 q2.5,-5 5,0 q2.5,5 5,0" stroke="white" strokeWidth="1.5" fill="none" />
      </pattern>
      <pattern id="pattern-grid" width="10" height="10" patternUnits="userSpaceOnUse">
        <rect width="10" height="10" fill="currentColor" />
        <line x1="5" y1="0" x2="5" y2="10" stroke="white" strokeWidth="1" />
        <line x1="0" y1="5" x2="10" y2="5" stroke="white" strokeWidth="1" />
      </pattern>
      <pattern id="pattern-circles" width="10" height="10" patternUnits="userSpaceOnUse">
        <rect width="10" height="10" fill="currentColor" />
        <circle cx="5" cy="5" r="3" stroke="white" strokeWidth="1" fill="none" />
      </pattern>
      <pattern id="pattern-triangles" width="10" height="10" patternUnits="userSpaceOnUse">
        <rect width="10" height="10" fill="currentColor" />
        <path d="M5,2 l3,6 l-6,0 z" stroke="white" strokeWidth="1" fill="none" />
      </pattern>
    </defs>
  );
}
